<template>
  <v-app>
    <ModalActions/>
    <ModalInfo/>
    <alerts></alerts>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
